export default __webpack_public_path__ + "static/media/second.f909f2f5.png";